/*
Add atom effect to console log all updates
(note this is a Recoil effect and NOT a React effect)
e.g.
export const someAtom = atom({
  key: 'someAtom',
  effects: [ effectConsoleLogAtomUpdates ]
})
*/
export const effectConsoleLogAtomUpdates = ({ onSet }: any) => {
  onSet((data: any) => {
    /* eslint-disable no-console */
    console.log('Atom SET:', data);
  });
};
